import { render, staticRenderFns } from "./RootContabilitaInviaView.vue?vue&type=template&id=0bf212ae&"
import script from "./RootContabilitaInviaView.vue?vue&type=script&lang=ts&"
export * from "./RootContabilitaInviaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports